module.exports = __webpack_public_path__ + "static/img/3_03.7f2a7777.png";